import { RefObject, useEffect } from "react";

const checkIsOutside = <T extends HTMLElement>(
  ref: RefObject<T>,
  target: Node,
) => !ref.current?.contains(target);

export const useClickOutside = <T extends HTMLElement>(
  refs: RefObject<T> | RefObject<T>[],
  handler: (event: MouseEvent) => void,
): void => {
  useEffect(() => {
    const listener = (event: MouseEvent) => {
      if (Array.isArray(refs)) {
        if (refs.every(ref => checkIsOutside(ref, event.target as Node))) {
          handler(event);
        }
      } else if (checkIsOutside(refs, event.target as Node)) {
        handler(event);
      }
    };

    document.addEventListener("mousedown", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, [refs, handler]);
};
